 /* eslint-disable */
import React, { useState, useEffect} from 'react'
import Metals from './Metals'
import AddMetal from './AddMetal'
import { getAllMetals } from '../../actions/metalActions'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import NoData from '../svgIcons/NoData'
import Spinner from '../Spinner/Spinner'


const MetalList = () => {

    const history = useHistory()
    const location = useLocation()
    const [openMetal, setOpenMetal] = useState(false)
    const [currentId, setCurrentId] = useState(null)
    const dispatch = useDispatch()
    const user = JSON.parse(localStorage.getItem('profile'))
    const {metals} = useSelector((state) => state.metals)
    const isLoading = useSelector(state => state.metals.isLoading)



useEffect(() => {

    dispatch(getAllMetals());
  },[location, dispatch])

  if(!user) {
    history.push('/login')
  }

  
  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

  if(metals.length === 0) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
      <NoData />
    <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No metals yet. Click the plus icon to add metal</p>
  
    </div>
  }

    return (
        <div>
            <AddMetal 
                openMetal={openMetal} 
                setOpenMetal={setOpenMetal}
                currentId={currentId}
                setCurrentId={setCurrentId}
            />
            <Metals 
                openMetal={openMetal} 
                setOpenMetal={setOpenMetal}
                currentId={currentId}
                setCurrentId={setCurrentId}
                metals={metals}
            />
        </div>
    )
}

export default MetalList

